import { render, staticRenderFns } from "./ExportWithdrawalsToExcel.vue?vue&type=template&id=756ed402&"
import script from "./ExportWithdrawalsToExcel.vue?vue&type=script&lang=js&"
export * from "./ExportWithdrawalsToExcel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports